module.exports = __webpack_public_path__ + "static/teachers-f9f186a33fd27b39a721f1d72bc81695.jpg";